import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/analytics";

/**
 * Fires a `$pageview` event into PostHog on every React Router
 * location change. Skips the very first render's duplicate when
 * combined with PostHog's autocapture-pageview, but our config
 * sets `capture_pageview: false` so this hook is the single source
 * of truth.
 *
 * Mounted once at the root of the app (inside <BrowserRouter>).
 * Returns null — no DOM output.
 */
export default function RouteTracker() {
  const location = useLocation();
  const lastPathRef = useRef(null);

  useEffect(() => {
    const path = location.pathname + location.search;
    if (lastPathRef.current === path) return;
    lastPathRef.current = path;
    trackPageView(location.pathname, { search: location.search });
  }, [location.pathname, location.search]);

  return null;
}
